export const citiesData = {
    "dallas-tx": {
        name: "Dallas, TX",
        heroSubtitle: "Hardened against seasonal hail, built for unprecedented growth.",
        localContext: "Dallas is experiencing explosive population and business growth, creating constant demand for reliable roofing contractors. Combined with fierce seasonal storms, high winds, and catastrophic hail, operators here need systems that can scale instantly without breaking. RoofClaw provides the autonomous infrastructure to capture this volatile market.",
        weatherFocus: "High Winds & Target Hail",
        marketFocus: "Rapid Sunbelt Expansion",
    },
    "miami-fl": {
        name: "Miami, FL",
        heroSubtitle: "Hurricane-ready command centers for high-velocity operations.",
        localContext: "Miami roofing operators face a unique dual-threat: intense, continuous UV degradation and the ever-present risk of catastrophic hurricane events. When a storm hits, lead volume 100x's overnight. A local, sovereign AI agent ensures your sales and production pipelines never buckle under the surge.",
        weatherFocus: "Hurricane & Torrential Rain",
        marketFocus: "High-Volume Surge Capacity",
    },
    "denver-co": {
        name: "Denver, CO",
        heroSubtitle: "Sovereign intelligence for the heart of Hail Alley.",
        localContext: "Sitting squarely in 'Hail Alley,' Denver roofing businesses experience some of the most concentrated and destructive weather events in the country. Managing the influx of insurance claims requires absolute operational precision. RoofClaw acts as a second brain, automating the chaos of storm response.",
        weatherFocus: "Catastrophic Hail Repair",
        marketFocus: "Insurance Claim Velocity",
    },
    "atlanta-ga": {
        name: "Atlanta, GA",
        heroSubtitle: "Navigating unpredictable weather with absolute system reliability.",
        localContext: "Atlanta's booming real estate market is battered by hot summers, heavy rains, and unpredictable severe weather. As the city expands, roofing contractors need robust, scalable systems to manage complex, multi-family and residential projects. OpenClaw provides the secure foundation for this growth.",
        weatherFocus: "Heavy Rain & Heat Stress",
        marketFocus: "Booming Real Estate Scale",
    },
    "chicago-il": {
        name: "Chicago, IL",
        heroSubtitle: "Engineered for intense seasonal shifts and urban density.",
        localContext: "Chicago tests roofing systems and the businesses that install them with extreme swings from brutal winters to scorching summers. In a highly dense, competitive urban market, efficiency is survival. RoofClaw automates the busywork so you can focus on complex urban logistics and high-margin projects.",
        weatherFocus: "Extreme Seasonal Stress",
        marketFocus: "High-Density Logistics",
    },
    "charlotte-nc": {
        name: "Charlotte, NC",
        heroSubtitle: "Scaling operations in a humid, high-growth environment.",
        localContext: "Charlotte is one of the fastest-growing markets in the country, bringing immense opportunity alongside the challenges of high humidity and surprise ice storms. To dominate this expanding territory, operators need an untiring digital workforce. RoofClaw handles the API routing so your human team can close deals.",
        weatherFocus: "Humidity & Ice Events",
        marketFocus: "Explosive Territorial Growth",
    },
    "austin-tx": {
        name: "Austin, TX",
        heroSubtitle: "Next-gen tech infrastructure for the modern roofing operator.",
        localContext: "Austin demands innovation. In a city driven by the tech sector and battered by Texas storms, progressive roofing companies are looking for an edge. RoofClaw provides a localized, secure AI architecture that aligns with Austin's forward-thinking market, automating workflows far beyond legacy SaaS limitations.",
        weatherFocus: "Extreme Heat & Wind",
        marketFocus: "Tech-Forward Efficiency",
    },
    "phoenix-az": {
        name: "Phoenix, AZ",
        heroSubtitle: "Unflinching performance under supreme thermal loads.",
        localContext: "Phoenix roofs endure extreme UV degradation and the sudden, violent impacts of monsoon downpours. The operational tempo here requires systems that do not overheat or delay. By moving operations off the cloud and onto an elite, local hardware node, RoofClaw ensures your business reacts faster than the competition.",
        weatherFocus: "Monsoons & UV Degradation",
        marketFocus: "High-Tempo Replacements",
    }
};
